import { render } from "./MainTabs.vue?vue&type=template&id=e482e920&ts=true"
import script from "./MainTabs.vue?vue&type=script&lang=ts"
export * from "./MainTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__